import { render, staticRenderFns } from "./KimPlayerInventoryComponent.vue?vue&type=template&id=0b85ee4c&scoped=true"
import script from "./KimPlayerInventoryComponent.vue?vue&type=script&lang=ts"
export * from "./KimPlayerInventoryComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimPlayerInventoryComponent.vue?vue&type=style&index=0&id=0b85ee4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85ee4c",
  null
  
)

export default component.exports